// extracted by mini-css-extract-plugin
export var header_wrapper = "header-module--header_wrapper--2qteE";
export var container = "header-module--container--hcrqD";
export var text_wrapper = "header-module--text_wrapper--1_5Ef";
export var bounce = "header-module--bounce--uRV3O";